export const messages = {
  en: {
    'general.unavailable': 'Something went wrong. Please try again.',
    'request.bad': 'The request could not be processed.',
    'request.forbidden': 'You do not have permission to do this.',
    'request.method_not_allowed': 'This action is not available.',
    'request.not_found': 'The requested item could not be found.',
    'request.rate_limited': 'Too many requests. Please try again shortly.',
    'request.validation_failed': 'Check the entered information and try again.',
    'auth.unauthenticated': 'Your session has expired. Please log in again.',
    'auth.invalid_credentials': 'The email address or password is incorrect.',
    'tenant.context_missing': 'This service is temporarily unavailable.',
    'tenant.not_found': 'This service is temporarily unavailable.',
    'payment.failed': 'The payment could not be completed. Please try again.',
    'payment.insufficient_funds': 'You do not have enough credits.',
    'payment.not_found': 'The payment could not be found.',
    'subscription.failed': 'The subscription could not be updated. Please try again.',
    'subscription.not_found': 'The subscription could not be found.',
    'chat.conversation_not_found': 'The conversation could not be found.',
    'chat.live_session_unavailable': 'The live session is not available right now.',
    'verification.disabled': 'Verification is not available right now.',
    'verification.expired': 'This verification request has expired.',
    'verification.forbidden': 'You cannot access this verification request.',
    'verification.init_failed': 'Verification could not be started. Please try again.',
    'verification.invalid_requirements': 'This verification request is invalid.',
    'verification.location_unavailable': 'Your location could not be determined.',
    'verification.not_found': 'The verification request could not be found.',
    'verification.payment_required': 'You do not have enough credits to start verification.',
    'verification.unsupported_type': 'This verification type is not supported.',
    'status.online': 'Online',
    'status.offline': 'Offline',
    'status.recently_online': 'Recently online',
    'status.pending': 'Pending',
    'status.processing': 'Processing',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.failed': 'Failed',
    'status.canceled': 'Canceled',
    'status.cancelled': 'Canceled',
    'status.expired': 'Expired',
    'status.paid': 'Paid',
    'status.completed': 'Completed',
    'status.active': 'Active',
  },
  nl: {
    'general.unavailable': 'Er is iets misgegaan. Probeer het opnieuw.',
    'request.bad': 'De aanvraag kon niet worden verwerkt.',
    'request.forbidden': 'Je hebt geen toestemming om dit te doen.',
    'request.method_not_allowed': 'Deze actie is niet beschikbaar.',
    'request.not_found': 'Het gevraagde item kon niet worden gevonden.',
    'request.rate_limited': 'Te veel aanvragen. Probeer het over een moment opnieuw.',
    'request.validation_failed': 'Controleer de ingevulde gegevens en probeer het opnieuw.',
    'auth.unauthenticated': 'Je sessie is verlopen. Log opnieuw in.',
    'auth.invalid_credentials': 'Het e-mailadres of wachtwoord is onjuist.',
    'tenant.context_missing': 'Deze dienst is tijdelijk niet beschikbaar.',
    'tenant.not_found': 'Deze dienst is tijdelijk niet beschikbaar.',
    'payment.failed': 'De betaling kon niet worden voltooid. Probeer het opnieuw.',
    'payment.insufficient_funds': 'Je hebt niet genoeg credits.',
    'payment.not_found': 'De betaling kon niet worden gevonden.',
    'subscription.failed': 'Het abonnement kon niet worden bijgewerkt. Probeer het opnieuw.',
    'subscription.not_found': 'Het abonnement kon niet worden gevonden.',
    'chat.conversation_not_found': 'Het gesprek kon niet worden gevonden.',
    'chat.live_session_unavailable': 'De live-sessie is nu niet beschikbaar.',
    'verification.disabled': 'Verificatie is nu niet beschikbaar.',
    'verification.expired': 'Dit verificatieverzoek is verlopen.',
    'verification.forbidden': 'Je hebt geen toegang tot dit verificatieverzoek.',
    'verification.init_failed': 'De verificatie kon niet worden gestart. Probeer het opnieuw.',
    'verification.invalid_requirements': 'Dit verificatieverzoek is ongeldig.',
    'verification.location_unavailable': 'Je locatie kon niet worden bepaald.',
    'verification.not_found': 'Het verificatieverzoek kon niet worden gevonden.',
    'verification.payment_required': 'Je hebt niet genoeg credits om de verificatie te starten.',
    'verification.unsupported_type': 'Dit verificatietype wordt niet ondersteund.',
    'status.online': 'Online',
    'status.offline': 'Offline',
    'status.recently_online': 'Onlangs online',
    'status.pending': 'In behandeling',
    'status.processing': 'Wordt verwerkt',
    'status.approved': 'Goedgekeurd',
    'status.rejected': 'Afgewezen',
    'status.failed': 'Mislukt',
    'status.canceled': 'Geannuleerd',
    'status.cancelled': 'Geannuleerd',
    'status.expired': 'Verlopen',
    'status.paid': 'Betaald',
    'status.completed': 'Voltooid',
    'status.active': 'Actief',
  },
};
